"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subdomainSelector = subdomainSelector;
function subdomainSelector(state) {
  return state.subdomain;
}